import { render, staticRenderFns } from "./editPoint.vue?vue&type=template&id=00a1fe94&"
import script from "./editPoint.vue?vue&type=script&lang=js&"
export * from "./editPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports